import { STOCK_FILTER_KEYS, type StockTableViewState } from '../../types/stockTableView.types';

export const areStockTableViewStatesEqual = (
  left: StockTableViewState,
  right: StockTableViewState,
): boolean => {
  if (left.searchQuery.trim() !== right.searchQuery.trim()) {
    return false;
  }

  return STOCK_FILTER_KEYS.every((key) => {
    const leftValues = [...left.selectedFilters[key]].sort();
    const rightValues = [...right.selectedFilters[key]].sort();

    if (leftValues.length !== rightValues.length) {
      return false;
    }

    return leftValues.every((value, index) => value === rightValues[index]);
  });
};

export const hasActiveStockFiltersOrSearch = (state: StockTableViewState): boolean => {
  if (state.searchQuery.trim() !== '') {
    return true;
  }

  return STOCK_FILTER_KEYS.some((key) => state.selectedFilters[key].length > 0);
};

export const createCustomViewId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `custom-${crypto.randomUUID()}`;
  }

  return `custom-${Date.now()}`;
};
